import { Switch } from '@mui/joy';
import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AccessPermissions } from 'core/enums';
import { hasPermission } from 'router/utils';
import { Size, Variant } from 'theme/enums';
import { DEFAULT_VERSION_TYPE_SETTING } from 'user/constants';
import { VersionViewType } from 'user/enums';
import { useUserSettingsActions } from 'user/hooks';

const SwitchVersion = ({
  defaultVersionViewType,
  userPermissions,
}: {
  defaultVersionViewType: VersionViewType;
  userPermissions: AccessPermissions[];
}) => {
  const [isChecked, setIsChecked] = useState(true);
  const [disabled, setDisabled] = useState(false);

  const { t } = useTranslation();

  const { upsertUserSetting } = useUserSettingsActions();

  useEffect(() => {
    setIsChecked(defaultVersionViewType === VersionViewType.PARTFINITI_V2);
  }, [defaultVersionViewType]);

  const handleOnChange = async (event: ChangeEvent<HTMLInputElement>) => {
    setDisabled(true);

    const { success } = await upsertUserSetting(
      {
        userSetting: {
          name: DEFAULT_VERSION_TYPE_SETTING,
          value: event.target.checked ? VersionViewType.PARTFINITI_V2 : VersionViewType.PARTFINITI,
        },
      },
      { onError: () => setDisabled(false) }
    );

    setDisabled(false);

    if (!success) {
      return;
    }

    setIsChecked(!event.target.checked);
  };

  if (!hasPermission([AccessPermissions.SWITCH_VERSION], userPermissions)) {
    return null;
  }

  return (
    <Switch
      variant={disabled ? Variant.OUTLINED : Variant.SOLID}
      size={Size.LG}
      startDecorator={t('labelOldVersion')}
      endDecorator={t('labelNewVersion')}
      checked={isChecked}
      onChange={handleOnChange}
      disabled={disabled}
    />
  );
};

export default SwitchVersion;
